import React, { useId, useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import './ui.css';

/**
 * Expand and collapse: a heading row with one chevron that turns when open.
 * Controlled (open + onToggle) or not (defaultOpen).
 */
export default function Disclosure({ summary, children, open: openProp, onToggle, defaultOpen = false, className = '' }) {
  const [ownOpen, setOwnOpen] = useState(defaultOpen);
  const open = openProp ?? ownOpen;
  const id = useId();
  const toggle = () => {
    if (onToggle) onToggle(!open);
    if (openProp === undefined) setOwnOpen(!open);
  };
  return (
    <div className={`ui-disclosure ${className}`.trim()}>
      <button type="button" className="ui-disclosure__toggle" aria-expanded={open} aria-controls={id} onClick={toggle}>
        <span>{summary}</span>
        <ChevronDownIcon className="ui-chevron" aria-hidden="true" />
      </button>
      <div id={id} hidden={!open}>{open && children}</div>
    </div>
  );
}

// The chevron on its own, for toggles laid out differently: put it inside
// the element that has aria-expanded
export function Chevron() {
  return <ChevronDownIcon className="ui-chevron" aria-hidden="true" />;
}
